import {fetch} from '../../utils/dataAccess';

export default async function updateReceiptNumber(receiptId, value) {
    const response = await fetch(
        `/receipts/${receiptId}`,
        {
            method: 'PATCH',
            body: JSON.stringify({value}),
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        },
    );
    return await response.json();
}
